import React from 'react';
import { Link } from 'react-router-dom';
import RSVP_OPEN from '../config/rsvp';
import CountdownTimer from '../components/CountdownTimer';
import Footer from '../components/Footer';

export default function Home() {

  return (
    <div className="site-wrapper">
      {/* Hero */}
      <section className="home-hero">
        <video
          className="hero-video-layer"
          src="/Backgroundwaves.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="home-hero-content">
          <div className="hero-eyebrow" style={{
            fontFamily: 'var(--font-sans)',
            fontSize: '0.72rem',
            fontWeight: 500,
            letterSpacing: '0.35em',
            textTransform: 'uppercase',
            color: 'var(--green-dark)',
            marginBottom: '1.2rem',
          }}>We're Getting Married</div>
          <h1 className="hero-names" style={{
            fontFamily: 'var(--font-script)',
            fontSize: 'clamp(3.5rem, 9vw, 6rem)',
            color: 'var(--green-dark)',
            lineHeight: 1.1,
            fontWeight: 400,
            letterSpacing: 'normal',
            textShadow: '0 2px 20px rgba(255,255,255,0.3)',
          }}>
            Caroline <span style={{ padding: '0 0.15em' }}>&amp;</span> Michael
          </h1>
          <div className="hero-date" style={{
            fontFamily: 'var(--font-sans)',
            fontSize: '0.72rem',
            fontWeight: 500,
            letterSpacing: '0.35em',
            textTransform: 'uppercase',
            color: 'var(--green-dark)',
          }}>
            <span>10 · 30 · 26</span> &nbsp;&middot;&nbsp; Naples, Florida
          </div>
          <div className="hero-actions">
            {RSVP_OPEN && <Link to="/rsvp" className="btn btn-gold">RSVP Now</Link>}
            <Link to="/schedule" className={`btn ${RSVP_OPEN ? 'btn-outline' : 'btn-gold'}`}>
              View Schedule
            </Link>
          </div>
          <CountdownTimer />
        </div>

        <div className="hero-scroll-hint">
          <span>Scroll</span>
          <div className="hero-scroll-hint-arrow" />
        </div>
      </section>



      {/* Quick Info */}
      <section className="home-quickinfo">
        <div className="home-quickinfo-inner">
          <div className="quickinfo-grid">
            <div className="quickinfo-item">
              <div className="quickinfo-label">Welcome Party</div>
              <div className="quickinfo-value">Laplaya<br/>Beach Club</div>
              <div className="quickinfo-sub">Thursday, 6:00 PM ET</div>
            </div>
            <div className="quickinfo-item">
              <div className="quickinfo-label">Ceremony</div>
              <div className="quickinfo-value">Saint William<br/>Catholic Church</div>
              <div className="quickinfo-sub">Friday, 3:00 PM ET</div>
            </div>
            <div className="quickinfo-item">
              <div className="quickinfo-label">Reception</div>
              <div className="quickinfo-value">Naples Beach Club<br/>Four Seasons Resort</div>
              <div className="quickinfo-sub">Friday, 5:30 PM ET</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
